import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent('section', 'childDropdown', ['wrapper']);